import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { AddToCart } from '@grandvisionhq/carts-v2';
import { Price, Button } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { isNumber } from '@grandvisionhq/utils';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';

const CTAButton = ({ isOrderable , renderAddToCartButton , calculatedPrice , currency , activeSku , selectedQuantity , addToCartCallback  })=>{
    const { getLabel  } = useIntl();
    const { routes  } = useProductDetailContext();
    const caption = /*#__PURE__*/ React.createElement(Text, {
        component: "span",
        variant: "body-head"
    }, `${getLabel('products.solutions.addToBasket')} `, isNumber(calculatedPrice) && calculatedPrice > 0 && /*#__PURE__*/ React.createElement(Price, {
        value: calculatedPrice,
        currency: currency
    }));
    const props = {
        caption,
        onSuccess: addToCartCallback,
        lineItemDrafts: [
            {
                sku: activeSku,
                quantity: selectedQuantity !== null && selectedQuantity !== void 0 ? selectedQuantity : 1,
                type: 'regular'
            }
        ]
    };
    if (!isOrderable) {
        return /*#__PURE__*/ React.createElement(Button, {
            caption: getLabel('products.actions.excludedFromCheckout'),
            href: routes.stores
        });
    }
    return renderAddToCartButton ? renderAddToCartButton(props) : /*#__PURE__*/ React.createElement(AddToCart, swcHelpers.extends({}, props));
};

export { CTAButton, CTAButton as default };
//# sourceMappingURL=CTAButton.js.map
